var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import History from "@irati/utils/history";
import tracking from "@irati-tracking/perks/perks";
import Loading from "@irati/ui/src/Loading";
import { injectIntl } from "@irati/utils/lang";
import ErrorText from "@irati/ui/src/ErrorText";
import { waitPromise } from "@irati/utils/promise";
import basket from "@irati/checkout/utils/basket";
import redemptionUtils from "../../helpers/redemption/redemptionUtils";
import DealSEO from "../../components/DealSEO";
import ProductLayout from "../../components/ProductForms/ProductLayout";
import StockNotificationPopup from "../../components/ProductForms/StockNotificationPopup";
import SagaSteps from "../../constants/sagaSteps";
import OnLeaveRedemption from "../OnLeaveRedemption/OnLeaveRedemption";
import { getProductType } from "./getProductType";
import isNotWithinLimits from "./helpers/isNotWithinLimits";
import { birthdayBoxToProduct } from "./helpers/birthdayBoxToProduct";
import ErrorNotification from "../../components/ErrorNotification";
import RedeemProductForm from "./Product";
var RedeemProduct = /** @class */ (function (_super) {
    __extends(RedeemProduct, _super);
    function RedeemProduct(props) {
        var _this = _super.call(this, props) || this;
        _this.handleGetSaga = function () {
            var sagaId = get(_this.props, "match.params.sagaUuid", null);
            /**
             * Get latest saga - if next step is not order, error
             * Currently not redirecting as user cannot continue from steps - to be done
             */
            var load = redemptionUtils
                .handleIncorrectStep(sagaId)
                .then(function (saga) {
                if (saga.nextStep !== SagaSteps.ORDER) {
                    _this.setState({
                        deal: saga.deal,
                        saga: saga
                    });
                    throw new Error("Step already completed.");
                }
                else {
                    var products = birthdayBoxToProduct(get(saga, "redemption.fullDeal.birthdayBoxMetaData"), get(saga, "redemption.fullDeal.productConfig.products"));
                    _this.setState({
                        deal: saga.deal,
                        saga: saga,
                        productType: getProductType(saga.deal),
                        products: products
                    });
                    return _this.handleCheckStock(saga.deal.uuid).catch(_this.handleError);
                }
            })
                .catch(_this.handleError);
            _this.setState({ load: load });
        };
        _this.handleError = function (err) {
            var errorCode = err.errorCode, message = err.message, errorData = err.errorData;
            var error = redemptionUtils.handleSagaErrors(err);
            if (errorCode) {
                var formatMessage = _this.props.formatMessage;
                error = formatMessage({ id: message }, errorData);
            }
            _this.setState({
                error: error,
                block: false,
                submit: null
            });
        };
        /**
         * checks stock - sets state of products
         * @param productIds
         * @returns {Promise.<TResult>}
         */
        _this.handleCheckStock = function (dealId) {
            return redemptionUtils
                .checkStock(dealId)
                .then(function (_a) {
                var allProductsOutOfStock = _a.allProductsOutOfStock, outOfStock = _a.outOfStock;
                if (allProductsOutOfStock) {
                    _this.setState({ block: false });
                    _this.stockNotification.popup.open();
                }
                else if (outOfStock.length > 0) {
                    _this.setState({
                        outOfStock: !!_this.state.deal.productConfig.products.filter(function (prod) {
                            return outOfStock.indexOf(prod.uuid) > -1;
                        })
                    });
                }
            })
                .catch(_this.handleError);
        };
        _this.onContinue = function () {
            var _a = _this.state, deal = _a.deal, saga = _a.saga;
            tracking.redeemPerkSagaStatus(deal, saga);
            var submit = redemptionUtils
                .nextStep(saga, deal)
                .then(function (updatedSaga) {
                _this.setState({ block: false });
                return updatedSaga;
            })
                .then(function (updatedSaga) {
                var nextStep = redemptionUtils.currentStep(updatedSaga, deal);
                History.replace({
                    pathname: nextStep,
                    state: {
                        deal: deal,
                        saga: updatedSaga
                    }
                }, _this.context);
            })
                .catch(_this.handleError);
            _this.setState({ submit: submit });
        };
        _this.state = {
            saga: {},
            load: waitPromise(),
            products: [],
            deal: {},
            block: true,
            productType: null,
            outOfStock: false,
            canContinue: false
        };
        return _this;
    }
    RedeemProduct.prototype.componentDidMount = function () {
        var _this = this;
        this.handleGetSaga();
        basket.clear();
        this.basketSub = basket.subscribe(function () {
            _this.setState({
                canContinue: basket.items.length > 0 && !isNotWithinLimits(_this.state.deal)
            });
        });
    };
    RedeemProduct.prototype.componentWillUnmount = function () {
        if (this.basketSub) {
            this.basketSub.unsubscribe();
        }
    };
    RedeemProduct.prototype.render = function () {
        var _this = this;
        var _a = this.state, deal = _a.deal, submit = _a.submit, productType = _a.productType, products = _a.products, error = _a.error, load = _a.load, block = _a.block, canContinue = _a.canContinue;
        var formatMessage = this.props.formatMessage;
        return (React.createElement("div", null,
            React.createElement(Loading, { load: load },
                React.createElement(DealSEO, { deal: deal, pageTitle: formatMessage({ id: "perks.containers.redeemProduct.redeemProduct.dealSEO.pagetitle" }) }),
                React.createElement(OnLeaveRedemption, { block: block }),
                React.createElement(ProductLayout, { onClick: this.onContinue, deal: deal, disabled: !canContinue, loading: submit },
                    error && (React.createElement(ErrorNotification, null,
                        React.createElement(ErrorText, null, error))),
                    React.createElement(RedeemProductForm, { deal: deal, products: products, type: productType }))),
            React.createElement(StockNotificationPopup, { ref: function (c) {
                    _this.stockNotification = c;
                } })));
    };
    RedeemProduct.contextTypes = {
        // required for history redirect
        appPath: PropTypes.string.isRequired
    };
    return RedeemProduct;
}(Component));
export default injectIntl(RedeemProduct);
